import { useQuery } from '@tanstack/react-query';
import { useFilters } from '@/contexts/FilterContext';
import { barsApi } from '@/api/endpoints/bars';

/**
 * Lightweight check for whether bars exist in the current location/radius.
 * Shared across pages via React Query cache deduplication.
 */
export function useAreaCoverage() {
  const { lat, lng, radius, hasValidLocation } = useFilters();

  const { data, isLoading } = useQuery({
    queryKey: ['area-coverage', { lat, lng, radius }],
    queryFn: () => barsApi.list({ lat: lat!, lng: lng!, radius, limit: 1 }),
    enabled: hasValidLocation,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    hasBarCoverage: (data?.total ?? 0) > 0,
    isCheckingCoverage: isLoading,
  };
}
